import gql from "graphql-tag";

export const GET_REVIEWS = gql`
  query gerReviews($where: ReviewWhereInput, $first: Int, $skip: Int) {
    all: shop {
      id
      reviews {
        aggregate {
          count
        }
      }
    }
    paginate: shop {
      id
      reviews(
        where: $where
        first: $first
        skip: $skip
        orderBy: createdAt_DESC
      ) {
        aggregate {
          count
        }
        edges {
          node {
            createdAt
            fullName
            feedback
            answer
            type
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`;
